import { Directive, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[disableControl]',
    standalone: false
})
export class DisableControlDirective {
  @Input() disableControl: boolean=false;
  // @Input() set disableControl( condition : boolean ) {
  //   const action = condition ? 'disable' : 'enable';
  //   setTimeout(()=>{
  //       if (this.ngControl.control){
  //           this.ngControl.control[action]();
  //       }
  //     });
  //   // if (this.ngControl.control){
  //   //    this.ngControl.control[action]();
  //   // }
  // }

  ngOnChanges(changes: { disableControl: any; }) {
    if (changes.disableControl) {
      const action = this.disableControl ? 'disable' : 'enable';
      if (this.ngControl.control){
        this.ngControl.control[action]();
      }
    }
  }
  
  constructor( private ngControl : NgControl ) {
  }

}